export default function () {
  return {
    collectivity: undefined,
  };
}
